import React, { useMemo } from 'react';
import { ossImageUrl } from 'utils/const.js';
import { getPetInfoFromStorage } from 'utils/petStorage';
import { getPetAvatarSrc } from '../../pages/Pet/petPhaseConfig';
import './index.scss';

const PetAvatar = ({
    pet = null,
    className = '',
    alt = '悟空',
    style = {}
}) => {
    const { currentPetAvatar, phase } = useMemo(() => {
        const petData = pet || getPetInfoFromStorage();
        const phase = Number(petData?.garden_info?.PetInfo?.Phase) || 1;
        return {
            currentPetAvatar: getPetAvatarSrc(phase),
            phase,
        };
    }, [pet]);

    return (
        <img
            src={ossImageUrl(currentPetAvatar)}
            alt={alt}
            className={`pet-avatar pet-avatar-phase-${phase} ${className}`}
            style={style}
            loading="lazy"
            decoding="async"
        />
    );
};

export default PetAvatar;
